import React from 'react';
import Squiggle from "./Squiggle";

const TIERS = [
  ['1–5 active users', '$3', 'A small team or a single squad.'],
  ['6–20 active users', '$10', 'A department.'],
  ['21+ active users', '$50', 'The whole company.'],
];

const INCLUDED = [
  'Unlimited decisions with linked conversations',
  'Suggestions and recall in any public channel',
  'Approvals and stakeholder nudges',
  'Deadline reminders and the Monday digest',
  'Outcome tracking and analytics',
  // Notion is only mentioned once the template is live (its URL is set at build time).
  process.env.REACT_APP_NOTION_TEMPLATE_URL
    ? 'CSV export, shareable reports and Notion sync'
    : 'CSV export and shareable reports',
  'Home tab dashboard',
  'Email support',
];

const QUESTIONS = [
  ['Who counts as an active user?', 'Anyone in your workspace who creates a decision, is added as a stakeholder, or approves or declines one. People who only see answers in a channel don’t count.'],
  ['What happens when we grow?', 'Your price moves to the next tier automatically when active users cross a band, and back down if they drop below it. There’s nothing to upgrade by hand.'],
  ['Do I need a card for the trial?', 'No. The trial runs for 7 days without a card, and nothing is charged if you don’t subscribe.'],
  ['Can I cancel any time?', 'Yes, in one click from the billing page. Your decisions stay exportable to CSV after you cancel.'],
];

const Pricing = () => {
  const paymentLink = process.env.REACT_APP_PAYMENT_LINK || 'https://decisiontracker.app/trial';

  return (
    <div className="dt">
      <section className="dt-hero dt-page-hero">
        <div className="dt-wrap">
          <h1 className="dt-page-title">Simple pricing for the <span className="dt-kept">whole team<Squiggle /></span></h1>
          <p className="dt-hero-sub">
            One price per workspace, based on how many people actually use it. Every feature on every plan.
          </p>
          <div className="dt-cta-row">
            <a className="dt-btn dt-btn-primary" href={paymentLink}>Start the 7-day free trial</a>
          </div>
          <p className="dt-fineprint">No card required.</p>
        </div>
      </section>

      <section className="dt-section dt-section--surface">
        <div className="dt-wrap">
          <div className="dt-tiers">
            {TIERS.map(([range, price, note]) => (
              <div className="dt-tier" key={range}>
                {price === '$3' && <span className="dt-note dt-note--price" aria-hidden="true">less than a coffee</span>}
                <div className="dt-tier-range">{range}</div>
                <div className="dt-tier-price">{price}<span>/month</span></div>
                <p className="dt-tier-note">{note}</p>
              </div>
            ))}
          </div>

          <div className="dt-split" style={{ marginTop: 'clamp(56px, 7vw, 88px)' }}>
            <div>
              <h2 className="dt-h2">Everything is included</h2>
              <p className="dt-body" style={{ marginTop: 14 }}>
                No feature gates and no add-ons. The only thing that changes between plans is the size of the team.
              </p>
            </div>
            <ul className="dt-checklist">
              {INCLUDED.map((item) => <li key={item}>{item}</li>)}
            </ul>
          </div>
        </div>
      </section>

      <section className="dt-section">
        <div className="dt-wrap dt-faq">
          <h2 className="dt-h2">Billing questions</h2>
          <div className="dt-faq-list">
            {QUESTIONS.map(([q, a]) => (
              <details className="dt-faq-item" key={q}>
                <summary>{q}</summary>
                <p>{a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;



// WEBPACK FOOTER //
// ./src/components/Pricing.js